/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Psychology21Inputs */

const en__field_enum_csjensblank_psychology21 = /** @type {(inputs: _Field_Enum_Csjensblank_Psychology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychology`)
};

const de__field_enum_csjensblank_psychology21 = /** @type {(inputs: _Field_Enum_Csjensblank_Psychology21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychologie`)
};

/**
* | output |
* | --- |
* | "Psychology" |
*
* @param {_Field_Enum_Csjensblank_Psychology21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_psychology21 = /** @type {((inputs?: _Field_Enum_Csjensblank_Psychology21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Psychology21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_psychology21(inputs)
	return de__field_enum_csjensblank_psychology21(inputs)
});
export { _field_enum_csjensblank_psychology21 as "_field_enum_CSJENSBLANK_PSYCHOLOGY" }